import { r4Client, r4Error } from '@/services'

const EmailSenderApi = {
  async fetchSenders ({ dealerId, rooftopId }) {
    try {
      const resp = await r4Client().get('/api/v1/email_senders', { params: { dealer_id: dealerId, dealer_rooftop_id: rooftopId } })
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },
  async createSender (senderData) {
    try {
      const resp = await r4Client().post('/api/v1/email_senders', senderData)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },
  async updateSender (senderData) {
    try {
      const resp = await r4Client().put(`/api/v1/email_senders/${senderData.id}`, senderData)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },
  async saveSender (senderData) {
    if (senderData.id) {
      return this.updateSender(senderData)
    } else {
      return this.createSender(senderData)
    }
  },
  async getSender (dealerId, rooftopId, senderId) {
    try {
      const resp = await r4Client().get(`/api/v1/dealers/${dealerId}/rooftops/${rooftopId}/email_senders/${senderId}`)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  }
}

export default EmailSenderApi
